module.exports = __webpack_public_path__ + "static/media/g-3-a.e3a69c52.jpg";